import script from "./AutoCard.vue?vue&type=script&lang=js"
export * from "./AutoCard.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__